import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import {
  BaseResourceListComponent, Coluna, DateFormatPipe, Filtro,
  FormatoExportacao, GlobalService, LoginContabil, PreLiquidacaoResto
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreLiquidacaoRestoService } from '../service/pre-liquidacao-resto.service';

declare var $: any;

@Component({
  selector: 'lib-pre-liquidacao-resto-list',
  templateUrl: './pre-liquidacao-resto-list.component.html'
})
export class PreLiquidacaoRestoListComponent extends BaseResourceListComponent<PreLiquidacaoResto, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public especieSelect = 'PLR';
  public listaEspecies: Array<any>;
  public liquidacaoAnular: PreLiquidacaoResto;
  public ptBR: any;
  public datepipe: DatePipe;
  public data1: Date;
  public data2: Date;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private globalService: GlobalService,
    private preliquidacaoService: PreLiquidacaoRestoService) {
    super(preliquidacaoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'empenho,empenho.favorecido,liquidacoes';
  }

  protected condicoesGrid(): {} {
    const parametros = {};
    this.datepipe = new DatePipe('pt');
    parametros['data_liquidacao$ge'] = this.datepipe.transform(this.data1, 'yyyy-MM-dd');
    parametros['data_liquidacao$le'] = this.datepipe.transform(this.data2, 'yyyy-MM-dd');
    parametros['orgao.id'] = this.login.orgao.id;
    parametros['exercicio.id'] = this.login.exercicio.id

    sessionStorage.removeItem('/preliquidacoesresto_data1');
    sessionStorage.removeItem('/preliquidacoesresto_data2');

    return parametros;
  }

  protected ordenacaoGrid(): string[] {
    return ['data_liquidacao$DESC', 'id$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      number: ['id', 'empenho.numero', 'valor_liquidado', 'empenho.subelemento', 'empenho.favorecido.cpf_cnpj'],
      date: ['data_liquidacao'],
      text: ['empenho.favorecido.nome', 'empenho.subelemento_nome'],
    };
  }

  public beforeInit(): void {
    this.usarFiltroPersonalizado = true;
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
    const dt1: string = sessionStorage.getItem('/preliquidacoesresto_data1');
    const dt2: string = sessionStorage.getItem('/preliquidacoesresto_data2');
    if (!dt1) {
      this.data1 = new DateFormatPipe().transform(this.datepipe.transform(new Date(`01/01/${this.login.exercicio.ano}`), 'yyyy-MM-dd'), []);
    } else {
      this.data1 = new DateFormatPipe().transform(dt1, []);
    }
    if (!dt2) {
      this.data2 = new DateFormatPipe().transform(this.datepipe.transform(new Date(), 'yyyy-MM-dd'), []);
    } else {
      this.data2 = new DateFormatPipe().transform(dt2, []);
    }
  }

  protected afterInit(): void {
    this.listaEspecies = [
      { id: 'PLO', nome: 'ORÇAMENTÁRIA' },
      { id: 'PLR', nome: 'RESTOS A PAGAR' }
    ];
  }

  public anular(item) {
    this.liquidacaoAnular = item;

    $('#dialogAnular').modal('show');
  }

  protected acaoRemover(model: PreLiquidacaoResto): Observable<PreLiquidacaoResto> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Data', coluna: 'data_liquidacao', agrupar: true, bold: true },
      { titulo: 'Número', coluna: 'empenho.numero' },
      { titulo: 'Parcela', coluna: 'parcela' },
      { titulo: 'Beneficiario', coluna: 'empenho.favorecido.nome' },
      { titulo: 'Despesa', coluna: 'empenho.subelemento_nome' },
      { titulo: 'Historico', coluna: 'historico' },
      { titulo: 'Vencimento', coluna: 'data_vencimento' },
      { titulo: 'Valor', coluna: 'valor_liquidado', alignment: 'right', decimais: 2 }
    ];
  }

  public obterColunasfiltroPersonalizado(): {}[] {
    const retorno: Coluna[] = [];

    retorno.push({ titulo: 'Data', coluna: 'data_liquidacao', tipo: 'Date', alignment: 'center', padrao: true, filtro2: new Date() });
    retorno.push({ titulo: 'N° Empenho', coluna: 'empenho.numero', tipo: 'Number', padrao: true });
    retorno.push({ titulo: 'N° Parcela', coluna: 'parcela', tipo: 'Number', padrao: true, cols: 3 });
    retorno.push({ titulo: 'Descrição Despesa', coluna: 'empenho.subelemento_nome', tipo: 'String', alignment: 'center', cols: 4 });
    retorno.push({ titulo: 'N° Descrição Despesa', coluna: 'empenho.subelemento', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Anulado', coluna: 'anulacao', tipo: 'Boolean' });
    retorno.push({ titulo: 'Liquidado', coluna: 'anulado_total$ne,liquidacoes.id$not_null', tipo: 'Boolean' });
    retorno.push({ titulo: 'Valor Pré-Liquidado', coluna: 'valor_liquidado', tipo: 'Number', cols: 3 });
    retorno.push({ titulo: 'Favorecido Nome', coluna: 'empenho.favorecido.nome', tipo: 'String', alignment: 'center', cols: 4 });
    retorno.push({ titulo: 'Favorecido CPF/CPNJ', coluna: 'empenho.favorecido.cpf_cnpj', tipo: 'String', alignment: 'center', cols: 3 });
    retorno.push({ titulo: 'Ano Empenho', coluna: 'empenho.ano', tipo: 'Number', alignment: 'center', cols: 3 });
  
    return retorno;
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'empenho,empenho.favorecido,orgao,exercicio';
    this.preliquidacaoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          console.log(lista);
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE PRÉ-LIQUIDAÇÕES DE RESTOS A PAGAR',
              this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'landscape',
              'Listagem liquidações restos', ['auto', 'auto', '*', 'auto', '*', 'auto', 'auto'], lista.content, ['valor_liquidado']);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public onChangeLiquidacao(value: any, especie: any) {
    this.router.navigate(['pre-liquidacoes']);
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
      case 'controle-interno':
        this.router.navigate(['/contabilidade']);
        break;
      default:
        this.sair();
        break;
    }
  }
}
